/* istanbul ignore file */
import { FormLead } from './FormLead/FormLead';
import { HeadContent } from './HeadContent/HeadContent';
import { Testimonial } from './Testimonial/Testimonial';
import { Faq } from './Faq/Faq';
import { SelectField } from './SelectField/SelectField';
import { CheckboxField } from './CheckboxField/CheckboxField';
import { PIN } from './PIN/PIN';
import { Carousel } from './Carousel/Carousel';
import { PurchaseCard } from './PurchaseCard/PurchaseCard';
import { ProfileMenu } from './ProfileMenu/ProfileMenu';
import { Recomendations } from './Recomendations/Recomendations';
import { GamificationCard } from './GamificationCard/GamificationCard';
import * as Step from './Step/Step';

export {
  FormLead,
  HeadContent,
  Testimonial,
  Faq,
  SelectField,
  CheckboxField,
  PIN,
  Carousel,
  PurchaseCard,
  ProfileMenu,
  Recomendations,
  GamificationCard,
  Step,
};
